var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.47782 0C2.44335 0 0 2.44335 0 5.47782V24.5222C0 27.5567 2.44335 30 5.47782 30H15.7997V18.2719H12.6985V14.0494H15.7997V10.4419C15.7997 7.60764 17.6321 5.00532 21.8531 5.00532C23.5622 5.00532 24.826 5.16939 24.826 5.16939L24.7266 9.11253C24.7266 9.11253 23.4377 9.10035 22.0312 9.10035C20.5091 9.10035 20.265 9.80169 20.265 10.966V14.0494H24.8475L24.6478 18.2719H20.265V30.0001H24.5222C27.5567 30.0001 30 27.5567 30 24.5222V5.47785C30 2.44338 27.5567 3e-05 24.5222 3e-05H5.47779L5.47782 0Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.4cf79cc695d13f69ca9cb3758127390c.svg";
export { ForwardRef as ReactComponent };